export enum CashFlowstatus {
  OK = 'OK',
  DIFFERENCE = 'DIFFERENCE',
}

export const MAP_MONEY_SOURCE_STATUS = {
  [CashFlowstatus.OK]: 'Khớp',
  [CashFlowstatus.DIFFERENCE]: 'Không khớp',
}

export interface CashFlow {
  id: number
  date: string
  book_revenue: number
  cash_amount: number
  bank_transfer_amount: number
  difference_amount: number
  status: CashFlowstatus
  is_confirmed: boolean
  confirmed_by_id?: number
  confirmed_at?: string
  confirmed_by?: {
    id: number
    username: string
    full_name: string
  }
  notes?: string
  created_by_id: number
  created_at: string
  updated_at: string
  created_by: {
    id: number
    username: string
    full_name: string
  }
}

export interface CreateCashFlowDto {
  date: string
  book_revenue: number
  cash_amount: number
  bank_transfer_amount: number
  notes?: string
}

export interface UpdateCashFlowDto {
  date?: string
  book_revenue?: number
  cash_amount?: number
  bank_transfer_amount?: number
  notes?: string
}

export interface GetCashFlowsDto {
  from_date?: string
  to_date?: string
  status?: CashFlowstatus
  created_by_id?: number
  search?: string
  page?: number
  limit?: number
  sort?: string
  order?: 'asc' | 'desc'
}

export interface CashFlowResponse {
  data: CashFlow
  statusCode: number
  message: string
}

export interface DataCashFlow {
  items: CashFlow[]
  meta: {
    page: number
    limit: number
    pages: number
    total: number
  }
  statistics?: {
    total_book_revenue: number
    total_cash_amount: number
    total_bank_transfer_amount: number
    total_difference_amount: number
    ok_count: number
    difference_count: number
    total_count: number
  }
}

export interface CashFlowsResponse {
  data: DataCashFlow
  statusCode: number
  message: string
}

export interface CashFlowsSummaryResponse {
  data: {
    total_book_revenue: number
    total_cash_amount: number
    total_bank_transfer_amount: number
    total_difference_amount: number
    ok_count: number
    difference_count: number
    total_count: number
  }
  statusCode: number
  message: string
} 